import React from 'react';
import Grid from '@material-ui/core/Grid';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Typography, makeStyles, Box } from '@material-ui/core';
import PeopleIcon from '@material-ui/icons/People';
import { verySmall, small, medium, large, veryLarge } from '../constants';
import SocioEconomic from './SocioEconomic';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
    marginBottom: theme.spacing(1),
  },
  summary: {
    background: theme.palette.background.default,
  },
  details: {
    border: '1px solid rgba(105, 109, 117, 0.15)',
    justifyContent: 'center',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
    }
  },
}));

const getSize = (value) => (
  <Box display="flex" flexDirection="column" alignItems="center" flex={{ xs: 2, sm: 0 }}>
    <div>{<PeopleIcon fontSize="small" />}</div>
    <Typography style={{ whiteSpace: 'nowrap' }}>
      {(verySmall.includes(value) && 'Very Small') ||
        (small.includes(value) && 'Small') ||
        (medium.includes(value) && 'Medium') ||
        (large.includes(value) && 'Large') ||
        (veryLarge.includes(value) && 'Very Large') || 'N/A'}
    </Typography>
  </Box>
);

const getGraduates = (value) => (
  <Box display="flex" flexDirection="column" textAlign="center" flex={{ xs: 2, sm: 0 }}>
    <Typography variant="h6" align="center">
      {value}
      {!value && 'N/A'}
    </Typography>
    <Typography  style={{ whiteSpace: 'nowrap' }}>Undergraduate Students</Typography>
  </Box>
);

const getGraduationType = (value) => (
  <Box display="flex" alignItems="center">
    <Box display="flex" flexDirection="column" paddingX={2} textAlign="center">
      <Typography variant="h6">
        {100 - Math.round(value * 100)}%
      </Typography>
      <Typography style={{ whiteSpace: 'nowrap' }}>Full Time</Typography>
    </Box>
    <Box marginX={2}>
      <Typography variant="h6" align="center">
        /
      </Typography>
    </Box>
    <Box display="flex" flexDirection="column" paddingX={2} textAlign="center">
      <Typography variant="h6">
        {Math.round(value * 100)}%
      </Typography>
      <Typography style={{ whiteSpace: 'nowrap' }}>Part Time</Typography>
    </Box>
  </Box>
);

const StudentBody = ({ school }) => {
  const classes = useStyles();

  const data = [
    {
      name: 'White',
      val: Math.round(
        school['latest.student.demographics.race_ethnicity.white'] * 100,
      ),
    },
    {
      name: 'Asian',
      val: Math.round(
        school['latest.student.demographics.race_ethnicity.asian'] * 100,
      ),
    },
    {
      name: 'Non-Resident alien',
      val: Math.round(
        school[
          'latest.student.demographics.race_ethnicity.non_resident_alien'
        ] * 100,
      ),
    },
    {
      name: 'Two or more races',
      val: Math.round(
        school['latest.student.demographics.race_ethnicity.two_or_more'] * 100,
      ),
    },
    {
      name: 'Black',
      val: Math.round(
        school['latest.student.demographics.race_ethnicity.black'] * 100,
      ),
    },
    {
      name: 'American Indian/Alaska Native',
      val: Math.round(
        school['latest.student.demographics.race_ethnicity.aian'] * 100,
      ),
    },
    {
      name: 'Unknown',
      val: Math.round(
        school['latest.student.demographics.race_ethnicity.unknown'] * 100,
      ),
    },
    {
      name: 'Native Hawaiian/Pacific Islander',
      val: Math.round(
        school[
          'latest.student.demographics.race_ethnicity.asian_pacific_islander'
        ] * 100,
      ),
    },
  ];

  const CustomizedLabel = (props) => {
    return (
      <g>
        <text
          font-size="17"
          x={5}
          y={props.y}
          dy={22}
          dx={60}
          textAnchor="right"
          fill={'#626C82'}
        >
          {`${props.value}% ${data[props.index].name}`}
        </text>
      </g>
    );
  };

  return (
    <div className={classes.root}>
      <Accordion elevation={0}>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          IconButtonProps={{
            edge: 'start',
            color: 'inherit',
          }}
          className={classes.summary}
        >
          <Typography variant="body2">Student Body</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <Box
            flex={1}
            display="flex"
            justifyContent="space-around"
            flexDirection="column"
          >
            <Box
              display="flex"
              justifyContent="space-around"
              flexWrap="wrap"
              marginBottom={3}
            >
              {school && getSize(school['school.carnegie_size_setting'])}
              {school && getGraduates(school['latest.student.size'])}
              {school &&
                getGraduationType(school['latest.student.part_time_share'])}
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <SocioEconomic cx={80} cy={100} school={school} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography gutterBottom>Race/Ethnicity</Typography>
                <ResponsiveContainer height={300} width="100%">
                  <BarChart
                    data={data}
                    layout="vertical"
                  >
                    <XAxis type="number" hide />
                    <YAxis type="category" hide />
                    <Bar
                      background
                      name="name"
                      label={<CustomizedLabel />}
                      dataKey="val"
                      fill="#0f84ff8c"
                    />
                  </BarChart>
                </ResponsiveContainer>
              </Grid>
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default StudentBody;
